module.exports = __webpack_public_path__ + "img/block2-3.4012c863.jpg";